if (!customElements.get('product-recommendations')) {
  const ProductCarouselElement = customElements.get('product-carousel-element');

  customElements.define('product-recommendations', class extends ProductCarouselElement {
    constructor() {
      super();
      this.onLoadMoreClick = this.onLoadMoreClick.bind(this);
    }

    get sectionSelector() {
      return '.section-related-products';
    }

    async fetchProducts() {
      await super.fetchProducts();
      this.setUpLoadMore();
    }

    setUpLoadMore() {
      this.loadMoreTrigger = this.querySelector('[data-related-products-trigger]');
      if (!this.loadMoreTrigger) return;

      this.loadMoreTrigger.addEventListener('click', this.onLoadMoreClick);
    }

    onLoadMoreClick() {
      this.querySelectorAll('[data-related-products-item].is-hidden').forEach((item, index) => {
        item.classList.remove('is-hidden');
        item.classList.add('animate-reveal');
        item.style.animationDelay = `${Math.min(index * 40, 240)}ms`;
      });

      this.loadMoreTrigger.closest('.collection-load-more')?.remove();
      this.loadMoreTrigger.removeEventListener('click', this.onLoadMoreClick);
      this.loadMoreTrigger = null;
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();
      this.loadMoreTrigger?.removeEventListener('click', this.onLoadMoreClick);
    }
  });
}
